import gallery from '@/assets/gall1.png';
import agency from '@/assets/agncy.png';
import 'react-quill/dist/quill.snow.css';
import { useEffect, useState } from 'react';
import { Button } from '@/components/Elements';
import Modal from 'react-responsive-modal';
import close from '@/assets/close-circle.svg';
const AcceptedRequest = () => {
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const handleModal = () => {
    setOpen(false);
    onOpenModal();
  };
  return (
    <div className="agency-card-row accepted">
      <div className="row">
        <div className="col-12 col-md-4 col-xl-3 mb-4">
          <div className="agency-boxes">
            <img src={gallery} className="agency-icon" />
            <div className="d-flex agency-info-bs justify-between align-items-center">
              <h6 className="dark-gray mb-0">Agency 1</h6>
              <img src={agency} className="agency-info" />
            </div>
            <p className="f-13">103 Wright CourtBurien, WA 98168</p>
            <div className="row">
              <div className="col-12 col-md-6">
                <h5 className="mb-0">---</h5>
                <p className="f-13">Expertise</p>
              </div>
              <div className="col-12 col-md-6">
                <h5 className="mb-0">2548458692</h5>
                <p className="f-13">Mobile NUmber</p>
              </div>
            </div>
            <Button className="rounded-full w-100 mt-3 f-13 final-btn" onClick={handleModal} variant="outline" size="sm">
              Finalized
            </Button>
            <Button className="rounded-full w-100 mt-2 f-13" size="sm">
              View
            </Button>
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-3 mb-4">
          <div className="agency-boxes">
            <img src={gallery} className="agency-icon" />
            <div className="d-flex agency-info-bs justify-between align-items-center">
              <h6 className="dark-gray mb-0">Agency 1</h6>
              <img src={agency} className="agency-info" />
            </div>
            <p className="f-13">103 Wright CourtBurien, WA 98168</p>
            <div className="row">
              <div className="col-12 col-md-6">
                <h5 className="mb-0">---</h5>
                <p className="f-13">Expertise</p>
              </div>
              <div className="col-12 col-md-6">
                <h5 className="mb-0">2548458692</h5>
                <p className="f-13">Mobile NUmber</p>
              </div>
            </div>
            <Button className="rounded-full w-100 mt-3 f-13 final-btn" variant="outline" size="sm">
              Finalized
            </Button>
            <Button className="rounded-full w-100 mt-2 f-13" size="sm">
              View
            </Button>
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-3 mb-4">
          <div className="agency-boxes">
            <img src={gallery} className="agency-icon" />
            <div className="d-flex agency-info-bs justify-between align-items-center">
              <h6 className="dark-gray mb-0">Agency 1</h6>
              <img src={agency} className="agency-info" />
            </div>
            <p className="f-13">103 Wright CourtBurien, WA 98168</p>
            <div className="row">
              <div className="col-12 col-md-6">
                <h5 className="mb-0">---</h5>
                <p className="f-13">Expertise</p>
              </div>
              <div className="col-12 col-md-6">
                <h5 className="mb-0">2548458692</h5>
                <p className="f-13">Mobile NUmber</p>
              </div>
            </div>
            <Button className="rounded-full w-100 mt-3 f-13 final-btn" variant="outline" size="sm">
              Finalized
            </Button>
            <Button className="rounded-full w-100 mt-2 f-13" size="sm">
              View
            </Button>
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-3 mb-4">
          <div className="agency-boxes">
            <img src={gallery} className="agency-icon" />
            <div className="d-flex agency-info-bs justify-between align-items-center">
              <h6 className="dark-gray mb-0">Agency 1</h6>
              <img src={agency} className="agency-info" />
            </div>
            <p className="f-13">103 Wright CourtBurien, WA 98168</p>
            <div className="row">
              <div className="col-12 col-md-6">
                <h5 className="mb-0">---</h5>
                <p className="f-13">Expertise</p>
              </div>
              <div className="col-12 col-md-6">
                <h5 className="mb-0">2548458692</h5>
                <p className="f-13">Mobile NUmber</p>
              </div>
            </div>
            <Button className="rounded-full w-100 mt-3 f-13 final-btn" variant="outline" size="sm">
              Finalized
            </Button>
            <Button className="rounded-full w-100 mt-2 f-13" size="sm">
              View
            </Button>
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-3 mb-4">
          <div className="agency-boxes">
            <img src={gallery} className="agency-icon" />
            <div className="d-flex agency-info-bs justify-between align-items-center">
              <h6 className="dark-gray mb-0">Agency 1</h6>
              <img src={agency} className="agency-info" />
            </div>
            <p className="f-13">103 Wright CourtBurien, WA 98168</p>
            <div className="row">
              <div className="col-12 col-md-6">
                <h5 className="mb-0">---</h5>
                <p className="f-13">Expertise</p>
              </div>
              <div className="col-12 col-md-6">
                <h5 className="mb-0">2548458692</h5>
                <p className="f-13">Mobile NUmber</p>
              </div>
            </div>
            <Button className="rounded-full w-100 mt-3 f-13 final-btn" variant="outline" size="sm">
              Finalized
            </Button>
            <Button className="rounded-full w-100 mt-2 f-13" size="sm">
              View
            </Button>
          </div>
        </div>
      </div>
      <div className="agency-modal">
        <Modal open={open} onClose={onCloseModal} center>
          <button
            className="modal-close-button"
            onClick={onCloseModal}
            aria-label="Close"
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              background: 'none',
              border: 'none',
              fontSize: '40px',
              cursor: 'pointer',
            }}
          >
            <img src={close} className="close-circle" />
          </button>
          <section className=" agency-model">
            <h5 className="agency-title semi-bold">Contract</h5>
            <div className="conteact-modal m-0" style={{padding: "15px"}}>
              <p className="f-14 my-4">
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                Ipsum has been the industry's standard dummy text ever since For a limited time
                only, we have managed to secure an income producing six bedrooms HMO within
                proximity to Manchester City Centre. For a limited time only, we have managed to
                secure an income producing six bedrooms HMO within proximity to Manchester City
                Centre.
              </p>
              <p className="f-14 my-4">
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                Ipsum has been the industry's standard dummy text ever since For a limited time
                only, we have managed to secure an income producing six bedrooms HMO within
                proximity to Manchester City Centre. For a limited time only, we have managed to
                secure an income producing six bedrooms HMO within proximity to Manchester City
                Centre.
              </p>
            </div>
          </section>
          <div className="sub-btns d-flex gap-3 mt-4 align-items-center justify-left">
            <Button className="rounded-full">User Signature</Button>
            <Button className="rounded-full gray-btn"> Submit</Button>
          </div>
        </Modal>
      </div>
    </div>
  );
};
export default AcceptedRequest;
